import RetirementPlanningView from "./RetirementPlanningView";
import React, {useRef, useState, useEffect} from 'react';
import {retirementPlanning} from "./RetirementPlanningModule";

function RetirementPlanning(props) {
    const [retirementPlanning, setRetirementPlanning] = useState({
        serviceHeading: '',
        servicedata: [],
        iconbutton: '',
        nextsection: false

});

    return (
        <RetirementPlanningView/>
    );
}

export default RetirementPlanning;
